import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from 'environments/environment';
import {ToastrService} from 'ngx-toastr';
import {catchError, Observable, throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SupplierService {
    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private toastr: ToastrService
    ) {}
    //api url
    private apiUrl = environment.apiUrl;

    createSupplier(supplier: any): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/Supplier/AddSuppliers`, supplier)
            .pipe
            //catchError(this.error)
            ();
    }
    getSupplierList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Supplier/GetSupplierList`)
            .pipe
            //catchError(this.error)
            ();
    }
    getCityList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Supplier/GetCityLists`)
            .pipe
            //catchError(this.error)
            ();
    }
    getBreedList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Supplier/GetBreedLists`)
            .pipe
            // catchError(this.error)
            ();
    }
    getBirdTypeList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Supplier/GetBirdTypeLists`)
            .pipe
            //catchError(this.error)
            ();
    }

    getSupplierById(supplierId: number): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Supplier/GetSupplierById?id=${supplierId}`)
            .pipe
            //catchError(this.error)
            ();
    }
}
